<div class="fixed-min-header-height">
  <div class="container-fluid product-lisitng-wrapper cart-lisitng-wrapper" *ngIf="componentLoaded">
    <div class="row">
      <div class="col-12 fixed-width-right-column hide-accordion-heading">
        <div class="common-accordion quick-add-accordion accordion-open-default-ipad">
          <accordion [isAnimated]="true" [closeOthers]="true">
            <div class="off-white-bg" *ngIf="totalorderItemDiscontinueCount > 0">
              <span class="product-count d-block d-lg-none">{{totalorderItemDiscontinueCount}} Products</span>
              <accordion-group heading="Discontinued Products" [isOpen]="isFirstOpen">
                <div class="cart-column-spacing stock-listing off-white-bg">
                  <h3 class="d-none d-lg-flex" accordion-heading>Discontinued Products<span class="product-count">{{totalorderItemDiscontinueCount}}
                    <span *ngIf="totalorderItemDiscontinueCount > 1">products</span> <span *ngIf="totalorderItemDiscontinueCount == 1">product</span></span></h3>

                  <!--Mobile Out of Stock Listing-->
                  <div class="product-grid infinite-responsive scrollbar d-none d-lg-flex" infiniteScroll 
                  [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDownForItemDiscontinue()" 
                  [scrollWindow]="false" [horizontal]="true" >
                    <div class="product-wrapper" *ngFor="let product of orderItemDiscontinue">
                      <div class="overlay-text">
                        <p>This Product is Discontinued</p>
                      </div>
                      <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li>
                          <img
                    src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                      </ul>
                      <div class="product-inner-wrapper">
                        <div class="product-image">
                          <a href="javascript:void(0);">
                            <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                          </a>
                        </div>
                        <div class="product-description">
                          <a href="javascript:void(0);">
                            <h2>{{product.short_desc}}</h2>
                        </a>

                        </div>
                      </div>

                    </div>
                  </div>
                  <!--/Mobile Out of Stock Listing-->

                  <!--Desktop Out of Stock Listing-->
                  <div class="product-grid infinite-responsive scroll-body d-flex d-lg-none" infiniteScroll 
                  [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDownForItemDiscontinue()" 
                  [scrollWindow]="false">
                    <div class="product-wrapper with-tags" *ngFor="let product of orderItemDiscontinue">
                        <div class="overlay-text">
                            <p>This Product is Discontinued</p>
                          </div>
                      <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li >
                          <img
                          src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                      </ul>
                      <div class="product-image">
                        <a href="javascript:void(0);">
                          <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                      </a>
                      </div>
                      <div class="product-description">
                        <a href="javascript:void(0);">
                          <h2>{{product.short_desc}}</h2>
                      </a>

                      </div>
                    </div>
                  </div>
                  <!--/Desktop Out of Stock Listing-->
                </div>
              </accordion-group>
            </div>
            <div class="blue-bg" *ngIf="totalorderItemsNotInRangeCount > 0">
              <span class="product-count d-block d-lg-none">{{totalorderItemsNotInRangeCount}} Products</span>
              <accordion-group heading="Products Not in Range" [isOpen]="isFirstOpen">
                <div class="cart-column-spacing stock-listing blue-bg">
                  <h3 class="d-none d-lg-flex" accordion-heading>Products Not in Range<span class="product-count">{{totalorderItemsNotInRangeCount}}
                    <span *ngIf="totalorderItemsNotInRangeCount > 1">products</span> <span *ngIf="totalorderItemsNotInRangeCount == 1">product</span></span></h3>
                  <!--Mobile Back in Stock Listing-->
                  <div class="product-grid infinite-responsive scrollbar d-none d-lg-flex" infiniteScroll 
                  [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDownForItemsNotInRange()" 
                  [scrollWindow]="false" [horizontal]="true">
                    <div class="product-wrapper" *ngFor="let product of orderItemsNotInRange">
                        <div class="overlay-text">
                            <p>This Product is not available in your range</p>
                          </div>
                      <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li >
                          <img
                          src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                      </ul>
                      <div class="product-inner-wrapper">
                        <div class="product-image">
                          <a href="javascript:void(0);">
                            <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                        </a>
                        </div>
                        <div class="product-description">
                          <a href="javascript:void(0);">
                            <h2>{{product.short_desc}}</h2>
                        </a>

                        </div>
                      </div>

                    </div>
                  </div>
                  <!--/Mobile Back in Stock Listing-->

                  <!--Desktop Back in Stock Listing-->
                  <div class="product-grid infinite-responsive scroll-body d-flex d-lg-none" infiniteScroll 
                  [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDownForItemsNotInRange()" 
                  [scrollWindow]="false">
                    <div class="product-wrapper with-tags" *ngFor="let product of orderItemsNotInRange">
                        <div class="overlay-text">
                            <p>This Products is not available in your range</p>
                          </div>
                      <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li >
                          <img
                          src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                      </ul>
                      <div class="product-image">
                        <a href="javascript:void(0);">
                          <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                      </a>
                      </div>
                      <div class="product-description">
                        <a href="javascript:void(0);">
                          <h2>{{product.short_desc}}</h2>
                      </a>

                      </div>
                    </div>
                  </div>
                  <!--/Desktop Back in Stock Listing-->
                </div>
              </accordion-group>
            </div>
            <div class="pink-bg" *ngIf="totalorderItemOutofStockCount > 0">
              <span class="product-count d-block d-lg-none" *ngIf="totalorderItemOutofStockCount > 0">{{totalorderItemOutofStockCount}} <span *ngIf="totalorderItemOutofStockCount > 1">products</span> <span *ngIf="totalorderItemOutofStockCount == 1">product</span></span>
              <accordion-group heading="Out of Stock" [isOpen]="isFirstOpen">
                <div class="cart-column-spacing stock-listing pink-bg">
                  <h3 class="d-none d-lg-flex" accordion-heading>Out of stock<span class="product-count">{{totalorderItemOutofStockCount}}
                    <span *ngIf="totalorderItemOutofStockCount > 1">products</span> <span *ngIf="totalorderItemOutofStockCount == 1">product</span></span></h3>

                  <!--Mobile Out of Stock Listing-->
                  <div class="product-grid infinite-responsive scrollbar d-none d-lg-flex" infiniteScroll 
                  [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDownFororderItemOutofStock()" 
                  [scrollWindow]="false" [horizontal]="true">
                    <div class="product-wrapper" *ngFor="let product of orderItemOutofStock">
                      <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li >
                          <img
                    src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                      </ul>
                      <div class="product-inner-wrapper">
                        <div class="product-image">
                          <a href="javascript:void(0);">
                            <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                        </a>
                        </div>
                        <div class="product-description">
                          <a href="javascript:void(0);">
                            <h2>{{product.short_desc}}</h2>
                        </a>
                          <button class="btn primary-btn disabled">Out of Stock</button>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!--/Mobile Out of Stock Listing-->

                  <!--Desktop Out of Stock Listing-->
                  <div class="product-grid infinite-responsive scroll-body d-flex d-lg-none" infiniteScroll 
                  [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDownFororderItemOutofStock()" 
                  [scrollWindow]="false">
                    <div class="product-wrapper" *ngFor="let product of orderItemOutofStock">
                      <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li >
                          <img
                          src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                      </ul>
                      <div class="product-image">
                        <a href="javascript:void(0);">
                          <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                      </a>
                      </div>
                      <div class="product-description">
                        <a href="javascript:void(0);">
                          <h2>{{product.short_desc}}</h2>
                      </a>
                        <button class="btn primary-btn disabled">Out of Stock</button>
                      </div>
                    </div>

                  <!--/Desktop Out of Stock Listing-->
                </div>
              </div>
              </accordion-group>
            </div>
            <div class="off-white-bg table-lisitng">
              <span class="product-count d-block d-lg-none">{{totalorderItemAvailableCount}} Products</span>
              <accordion-group heading="Available Products" [isOpen]="isFirstOpen1">
                <div class="cart-column-spacing my-cart-listing white-bg">
                  <div class="my-cart-header">
                    <h3 class="d-none d-lg-flex">Available Products</h3>
                    <div class="remove-part" *ngIf='totalorderItemAvailableCount > 0'>
                      <span class="remove-all">
                        <a href="javascript:void(0)" (click)="removePopup(cartTemplate, 'All', '');">
                          <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="27" height="27"
                            viewBox="0 0 27 27">
                            <g fill="none" fill-rule="evenodd">
                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g
                                          transform="translate(-1320 -1005) translate(15 972) translate(30 30) translate(1275 3)">
                                          <rect width="26.615" height="26.615" fill="#FFF3F3" rx="12.313" />
                                          <g fill="#D9394C" fill-rule="nonzero">
                                            <path
                                              d="M10.037 3.825c.429 0 .841.181 1.132.497.29.316.436.742.4 1.17l-.711 8.48c-.033.385-.207.742-.492 1.003-.284.262-.654.406-1.04.406H2.536c-.387 0-.756-.144-1.04-.406-.285-.261-.46-.618-.492-1.003l-.712-8.48c-.035-.428.11-.854.4-1.17.291-.316.704-.497 1.133-.497h8.21zm0 1.145H1.826c-.11 0-.215.046-.29.127-.074.08-.11.19-.102.299l.712 8.48c.017.202.189.36.391.36h6.788c.203 0 .375-.158.392-.36l.711-8.48c.01-.11-.028-.218-.102-.299-.074-.08-.18-.127-.29-.127zM3.36 6.575c.317-.02.588.22.61.533l.324 4.915c.02.315-.219.588-.534.609l-.038.001c-.3 0-.55-.235-.57-.535l-.325-4.914c-.01-.153.04-.3.14-.415.101-.115.24-.184.393-.194zm2.571-.001c.316 0 .573.256.573.572v4.915c0 .315-.257.572-.573.572-.315 0-.572-.257-.572-.572V7.146c0-.316.257-.572.572-.572zm2.571 0c.153.01.292.08.393.195.1.115.15.262.14.415l-.324 4.914c-.02.3-.27.535-.57.535l-.039-.001c-.315-.021-.554-.294-.533-.61l.324-4.914c.021-.312.292-.554.61-.533zM7.734 0c.848 0 1.538.69 1.538 1.538v.564h2.018c.316 0 .572.257.572.572 0 .316-.256.573-.572.573H.572C.257 3.247 0 2.99 0 2.674c0-.315.257-.572.572-.572h2.019v-.564C2.591.69 3.281 0 4.129 0h3.605zm0 1.145H4.129c-.217 0-.393.176-.393.393v.539h4.39v-.54c0-.216-.176-.392-.392-.392z"
                                              transform="translate(7.604 5.07)" />
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>

                          Remove All</a></span> <span class="product-count">{{totalorderItemAvailableCount}} <span *ngIf="totalorderItemAvailableCount > 1">products</span> <span *ngIf="totalorderItemAvailableCount == 1">product</span></span>
                    </div>
                  </div>

                  <!--My Cart Listing-->

                  <div class="product-grid" *ngIf='totalorderItemAvailableCount > 0'>

                      <div class="product-wrapper with-tags" *ngFor="let product of orderItemAvailable">
                        <ul class="product-type" *ngIf="product.price_marked == 1">
                          <li >
                            <img
                            src="../../assets/images/pmp.svg" alt="checked icon" />
                          </li>
                        </ul>
                        <div class="product-image">
                          <a href="javascript:void(0);">
                            <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                        </a>
                        </div>
                        <div class="product-description">
                          <div class="product-detail-block">
                            <a href="javascript:void(0);">
                              <h2>{{product.short_desc}}</h2>
                          </a>
                          <ul class="product-code">
                              <li>{{product.barcode}}</li>
                              <li class="seperator">|</li>
                              <li>{{product.sku}}</li>
                          </ul>
                          </div>

                          <ul class="order-quantity-details">
                            <li>
                              <span>RSP</span>
                              <p> <span *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                  <span *ngIf="product.rsp == '0.00'">N/A</span>  
                                  <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))" class="black">per 100g</span>
                                  <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)" class="black">each</span>
                              </p>
                          </li>
                          <li>
                              <span>Case</span>
                              <p><strong>{{product.size_case}}</strong></p>
                          </li>
                          </ul>

                          <div class="stock" *ngIf="product.is_in_stock == 1">
                            <img src="../../assets/images/in-stock-icon.svg" alt="in-stock-icon">
                            In Stock
                          </div>
                          <div class="spinner-and-price">
                            <div class="spinner" id="spinnercart1_{{product.product_id}}">
                              <ngx-number-spinner id="spinerbtncart1_{{product.product_id}}"
                                  [value]="product.item_qty !='' ? toInteger(product.item_qty) : 1" [min]="0"
                                  (change)="qytUpdate(product, $event, removeFromcartTemplate)">
                              </ngx-number-spinner>
                            </div>
                          </div>


                          <div class="delete-product">
                            <a href="javascript:void(0);" title="Delete product" (click)="removePopup(cartTemplate, '', product);">
                              <img src="../../assets/images/delete.svg" alt="delete">
                            </a>
                          </div>

                        </div>
                      </div>
                      
                      <div class="view-all-order d-flex"><a href="javascript:void(0);" (click)="onScrollDownForavailableOrderItems()"
                        *ngIf="(this.nextPageForItemAvailable != 1 && this.nextPageForItemAvailable !== null) && !this.loading4" title="View More" class="btn primary-btn">View More</a></div>


                    <!--/My Cart Listing-->
                  </div>
                  <div class="row no-result" *ngIf="totalorderItemAvailableCount == 0 && componentLoaded">
                    <div class="col-12">
                        <div class="no-result-content">
                            <img src="../../assets/images/no-result.svg" alt="no-result">
                            <p>Sorry, no results found!</p>
                            <span>We couldn’t find what you’re looking for</span>
                        </div>
                    </div>
                </div>
                </div>
              </accordion-group>
            </div>
            
          </accordion>
        </div>
      </div>
      <div class="col-12 fixed-width-left-column" >
        <!-- Hide product filters here in ipad and mobile as it is controlled thorugh router in top controls div -->
        <div class="sticky-at-top">
                        <div class="white-bg">
                          <p *ngIf='totalorderItemAvailableCount > 0'>Are you sure you want to add {{totalorderItemAvailableCount}} <span *ngIf="totalorderItemAvailableCount > 1">products</span> <span *ngIf="totalorderItemAvailableCount == 1">product</span> to your order?</p>
                        
          <div class="place-order" *ngIf='totalorderItemAvailableCount > 0'>
            <a  href="javascript:void(0);" (click)="orderItemsAddToCart()" title="Place Order"></a>
            <ul>
              <li>
                <p>Add to Order</p>
              </li>
              <li>
                <img src="../../assets/images/forward-icon.svg" alt="place order">
              </li>
            </ul>
          </div>
          <a  routerLink="/order" title="Back to My Orders" class="back-to-orders-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10">
                <g fill="none" fill-rule="evenodd">
                    <g fill="#1F2227" fill-rule="nonzero" class="white">
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <path d="M2.502 7.834h7.432v.284-.284c.406 0 .733.337.733.748 0 .41-.327.748-.733.748H2.497l2.537 2.62c.283.292.283.76 0 1.052-.139.143-.326.222-.52.222-.196 0-.383-.078-.523-.222L.211 9.098C.075 8.958 0 8.767 0 8.57c0-.198.078-.388.216-.528L3.99 4.217c.29-.293.758-.289 1.044.01.279.294.274.762-.01 1.051L2.502 7.834z" transform="translate(-1684 -314) translate(1615 130) translate(20 163) translate(49 17)"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            Back to My Orders</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #cartTemplate>
  <div class="modal-header border-0 pb-2">
    <h4 class="modal-title">Confirmation!</h4>
    <button type="button" class="close  " aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g fill="none" fill-rule="evenodd">
            <g stroke="#9B9B9B" stroke-width="1.75">
              <g>
                <g>
                  <path d="M14 0L0 14M0 0L14 14"
                    transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                </g>
              </g>
            </g>
          </g>
        </svg></span>
    </button>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>{{removeHeading}}</p>
        </div>
        <div class="button-div text-center mt-3">
          <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
          <button class="common-button ghost" *ngIf="removeType == ''" (click)="removeItem(removeProduct)">Confirm</button>
          <button class="common-button ghost" *ngIf="removeType != ''" (click)="clearCart()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #removeFromcartTemplate>
  <div class="modal-header border-0 pb-2">
    <h4 class="modal-title">Confirmation!</h4>
    <button type="button" class="close  " aria-label="Close" (click)="cancleRequest(removeProduct)">
      <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g fill="none" fill-rule="evenodd">
            <g stroke="#9B9B9B" stroke-width="1.75">
              <g>
                <g>
                  <path d="M14 0L0 14M0 0L14 14"
                    transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                </g>
              </g>
            </g>
          </g>
        </svg></span>
    </button>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>Are you sure you want to remove product from cart?</p>
        </div>
        <div class="button-div text-center mt-3">
          <button class="common-button mr-3" (click)="cancleRequest(removeProduct)">Cancel</button>
          <button class="common-button ghost" (click)="removeItem(removeProduct)">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>